import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream-beige" data-id="element-84" data-mp="bjw7e2yctbx8">
      <div className="max-w-6xl mx-auto" data-id="element-85" data-mp="bi1n8quwpnu7">
        <div className="text-center mb-16" data-id="element-86" data-mp="gb4ir4j8v7d1">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy-deep" data-id="element-87" data-mp="gc5vddfws1wv">
            What BJJ instructors who already have the system say
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-88" data-mp="q7pmznnfweft">
          {extendedTestimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-cream-card border border-gold-light p-8 rounded-2xl relative shadow-sm ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-89" data-mp="u8jf6t7x0fei" data-mpi={index}>
              <QuoteIcon className="absolute top-6 right-6 text-gold/20" size={48} aria-hidden="true" data-id="element-90" data-mp="37zd32ddjk8rb" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-91" data-mp="2yzzs1g9rrc4h">
                {[...Array(5)].map((_, star) => <StarIcon key={star} size={16} fill="currentColor" data-id="element-92" data-mp="3vnnvcs56903z" data-mpi={star} />)}
              </div>
              <blockquote className="text-ink italic mb-8 relative z-10 leading-relaxed" data-id="element-93" data-mp="3mpc1mh90dm7b">
                &quot;{testimonial.text}&quot;
              </blockquote>
              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-94" data-mp="3hpzd7s2ho72m">
                <div className="w-12 h-12 rounded-full bg-navy-deep flex items-center justify-center text-gold-light font-bold text-lg" data-id="element-95" data-mp="2bb6pv22k081f">
                  {testimonial.initials}
                </div>
                <div data-id="element-96" data-mp="27taqlv46ayp3">
                  <div className="font-bold text-navy-deep" data-id="element-97" data-mp="27t0xhynu0bf6">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-navy-mid" data-id="element-98" data-mp="2coydu4z3hhry">{testimonial.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}